export default __webpack_public_path__ + "static/media/baby.73633312.svg";